var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.332 40C43.332 34.4771 47.8092 30 53.332 30H89.9987L116.665 56.6667V120C116.665 125.523 112.188 130 106.665 130H53.332C47.8092 130 43.332 125.523 43.332 120V40Z",
    stroke: "#212121",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M86.668 30V60H116.668",
    stroke: "#212121",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCover);
export default __webpack_public_path__ + "static/media/uploadCover.f32f6828bee22a73bc9f8bc7f612daf4.svg";
export { ForwardRef as ReactComponent };